/* @ngInject */
function HomePostsItemController ($scope) {
}

export { HomePostsItemController }
